var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 5.50326C3 3.56846 4.51798 2 6.39053 2L17.6093 2.00003C19.4818 2.00003 20.9998 3.56849 20.9998 5.50329M3 5.50326C3 7.43806 4.51798 9.00652 6.39053 9.00652L17.6093 9.00655C19.4818 9.00655 20.9998 7.43809 20.9998 5.50329M3 5.50326L3.00016 18.3901C3.00016 21.3057 4.51816 22 6.39071 22H17.6094C19.482 22 21 21.3057 21 18.3901L20.9998 5.50329M9 6V6C9 4.89544 9.89542 4.00002 11 4.00002H13.1749C14.2795 4.00002 15.1749 4.89544 15.1749 6V6M9.66272 14.5L7 13.933L8.73965 18.6651L15.9883 17.3237L16 12.1449L13.6213 13.6931L11.2781 11.6651L9.66272 14.5Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.0982810f11a74871298c99549a81c02f.svg";
export { ForwardRef as ReactComponent };